<template>
    <div class="score-content">
        <div><span class="big-score">4</span><span class="small-score"> / 5</span></div>
        <div class="score-title">评分</div>
    </div>
</template>
<script>
export default {
    name: 'Score',
}
</script>
<style lang="less" scoped>
.score-content {
    width: 124px;
    height: 108px;
    background: url('../../../assets/image/score-bg.png') no-repeat;
    background-size: 100% 100%;
    padding-top: 6px;

    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: #fff;
    justify-content: flex-start;
    align-items: center;
}

.big-score {
    font-weight: 600;
    font-size: 28px;
    color: #00FFC6;
}

.small-score {
    font-size: 14px;
    color: #fff;
    font-weight: 600;
}

.score-title {
    margin-top: 10px;
    color: #fff;
    font-size: 14px;
}
</style>